import React from "react";

const VectorSea = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1440 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            {...props}
        >
            {/* Boat 1: Far, smaller - behind Deep Sea */}
            <g className="boat-1" stroke="#5D4037" strokeWidth="0.5">
                <g transform="translate(880, 135) scale(1)">
                    <path d="M5 25 Q30 35 60 30 L85 20 L80 10 H15 L5 25Z" fill="#FFFFFF" />
                    <path d="M10 22 Q30 30 60 26 L82 18" stroke="#EF5350" strokeWidth="2" fill="none" />
                    <path d="M25 10 L30 -5 H60 L65 10 H25Z" fill="#FFF3E0" />
                    <rect x="35" y="0" width="20" height="5" fill="#f758cfff" stroke="none" />
                    <path d="M28 -5 H62 L65 -2 H25 L28 -5Z" fill="#FF7043" />
                    {/* Centered Mast and Flag */}
                    <line x1="45" y1="-5" x2="45" y2="-18" stroke="#5D4037" strokeWidth="1" />
                    <path d="M45 -18 L60 -13 L45 -8 Z" fill="#00f8d7ff" stroke="none" />
                </g>
            </g>

            {/* Deep Sea - Bottom Layer */}
            <path
                fill="#0277BD"
                d="M0,160 Q60,165 120,160 T240,160 T360,160 T480,160 T600,160 T720,160 T840,160 T960,160 T1080,160 T1200,160 T1320,160 T1440,160 V320 H0 V160 Z"
            />

            {/* Boat 2: Mid, medium - behind Mid Deep Sea */}
            <g className="boat-2" stroke="#5D4037" strokeWidth="0.5">
                <g transform="translate(600, 148) scale(1.1)">
                    <path d="M0 20 Q20 35 80 30 L95 15 L85 5 H10 L0 20Z" fill="#FFFFFF" />
                    <path d="M5 20 Q22 32 75 28 L92 15 L5 20" fill="#e6a122ff" opacity="0.9" stroke="none" />
                    <path d="M20 5 L25 -12 H60 L65 5 H20Z" fill="#FFF9C4" />
                    <path d="M18 -12 H62 L65 -15 H22 L18 -12Z" fill="#df993dff" />
                    <rect x="28" y="-8" width="12" height="6" rx="1" fill="#4FC3F7" stroke="none" />
                    <rect x="45" y="-8" width="12" height="6" rx="1" fill="#4FC3F7" stroke="none" />
                    {/* Centered Mast (Taller) and Flag */}
                    <line x1="42.5" y1="-15" x2="42.5" y2="-33" stroke="#5D4037" strokeWidth="1" />
                    <path d="M42.5 -33 L58 -27 L42.5 -21 Z" fill="#FFEB3B" stroke="none" />
                    <circle cx="85" cy="15" r="3" fill="#FF5252" stroke="none" />
                </g>
            </g>

            {/* Mid Deep Sea */}
            <path
                fill="#0288D1"
                d="M0,180 Q60,185 120,180 T240,180 T360,180 T480,180 T600,180 T720,180 T840,180 T960,180 T1080,180 T1200,180 T1320,180 T1440,180 V320 H0 V180 Z"
            />

            {/* Boat 3: Near, larger - behind Mid Sea */}
            <g className="boat-3" stroke="#5D4037" strokeWidth="0.5">
                <g transform="translate(330, 150) scale(1.2)">
                    <path d="M0 30 Q40 45 100 35 L110 15 L100 5 H20 L0 30Z" fill="#FFFFFF" />
                    <path d="M5 25 H105" stroke="#00897B" strokeWidth="2.5" />
                    <rect x="30" y="-10" width="50" height="15" fill="#FFECB3" />
                    <rect x="35" y="-5" width="15" height="8" fill="#81D4FA" stroke="none" />
                    <rect x="60" y="-5" width="15" height="8" fill="#81D4FA" stroke="none" />
                    <path d="M25 -10 H85 L88 -6 H22 L25 -10Z" fill="#8D6E63" />
                    <circle cx="15" cy="15" r="4" fill="#FF5722" stroke="none" />
                    {/* Centered Mast and Flag */}
                    <line x1="55" y1="-10" x2="55" y2="-40" stroke="#5D4037" strokeWidth="1.5" />
                    <path d="M55 -40 L80 -32 L55 -24 Z" fill="#FF5252" stroke="none" />
                </g>
            </g>

            {/* Whale: Redrawn to match the latest cute image */}
            <g className="vector-whale">
                <g transform="translate(760, 150) scale(1.2)">
                    {/* Tail - Notched fluke matching reference image */}
                    <path
                        d="M30,35 C20,35 15,38 5,45 C-5,52 -10,50 -5,35 C0,30 -5,25 -10,15 C-10,5 0,0 8,10 C15,20 20,35 30,35 Z"
                        fill="#274472"
                    />

                    {/* Body - Main (Dark Top, Slimmer) */}
                    <path
                        d="M10,30 C10,18 140,18 140,30 C140,35 130,38 75,38 C40,38 10,35 10,30 Z"
                        fill="#274472"
                    />

                    {/* Belly area - White (Lower Half, Slimmer) */}
                    <path
                        d="M10,30 C10,48 40,58 75,58 C115,58 140,48 140,30 C140,35 130,38 75,38 C40,38 10,33 10,30 Z"
                        fill="#d4f2fdff"
                        opacity="0.95"
                    />

                    {/* Eye - Adjusted for slimmer head */}
                    <circle cx="120" cy="28" r="4.5" fill="white" />
                    <circle cx="120" cy="28" r="2.8" fill="black" />

                    {/* Pectoral Fin - At slimmer body/belly junction */}
                    <path
                        d="M60,38 C55,48 70,52 75,41 Z"
                        fill="#213a63"
                        opacity="0.9"
                    />

                    {/* Spout - Moved further Right and Touching the head */}
                    <g className="whale-spout">
                        <path d="M95,22 L95,12" stroke="#D1E8E2" strokeWidth="2" strokeLinecap="round" />
                        <path
                            d="M95,12 C85,2 90,-3 95,2 C100,-3 105,2 95,12"
                            fill="#D1E8E2"
                        />
                    </g>
                </g>
            </g>

            {/* Mid Sea */}
            <path
                fill="#03A9F4"
                d="M0,200 Q60,205 120,200 T240,200 T360,200 T480,200 T600,200 T720,200 T840,200 T960,200 T1080,200 T1200,200 T1320,200 T1440,200 V320 H0 V200 Z"
            />

            {/* Shallow Sea */}
            <path
                fill="#4FC3F7"
                d="M0,220 Q60,223 120,220 T240,220 T360,220 T480,220 T600,220 T720,220 T840,220 T960,220 T1080,220 T1200,220 T1320,220 T1440,220 V320 H0 V220 Z"
            />

            {/* Shore foam/line */}
            <path
                fill="#E1F5FE"
                d="M0,240 Q60,242 120,240 T240,240 T360,240 T480,240 T600,240 T720,240 T840,240 T960,240 T1080,240 T1200,240 T1320,240 T1440,240 V320 H0 V240 Z"
                opacity="0.9"
            />
        </svg>
    );
};

export default VectorSea;
